<template>
  <div class="period-dropdown-filter">
    <b-dropdown
      class="period-dropdown-filter__dropdown"
      right
      no-caret
    >
      <template slot="button-content" class="pr-0">
        <div class="period-dropdown-filter__button-content">
          <span
            class="period-dropdown-filter__button-content__text"
          >
            {{ currentSelectionText }}
          </span>
          <span
            class="period-dropdown-filter__button-content__icon material-icons">
            arrow_drop_down
            event
          </span>
        </div>
      </template>
      <template>
        <b-dropdown-item
          v-for="(option, index) in options"
          :key="index"
          @click="dropdownItemClick(option)"
        >
          {{ option.text }}
        </b-dropdown-item>
      </template>
    </b-dropdown>
  </div>
</template>

<script>
import periods from '@/domain/enums/periods-dropdown-filter';

export default {
  name: 'PeriodDropdownFilter',
  props: {
    value: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      options: [
        { text: this.$t('reports.period.all'), value: periods.ALL },
        { text: this.$t('reports.period.last-days', { days: periods.SEVEN }), value: periods.SEVEN },
        { text: this.$t('reports.period.last-days', { days: periods.FIFTEEN }), value: periods.FIFTEEN },
        { text: this.$t('reports.period.last-days', { days: periods.THIRTY }), value: periods.THIRTY },
        { text: this.$t('reports.period.last-days', { days: periods.ONE_HUNDRED_EIGHTY }), value: periods.ONE_HUNDRED_EIGHTY },
        { text: this.$t('reports.period.last-days', { days: periods.THREE_HUNDRED_SIXTY_FIVE }), value: periods.THREE_HUNDRED_SIXTY_FIVE },
      ],
    };
  },
  computed: {
    currentSelectionText() {
      const option = (this.options || []).find(x => x.value === this.value);
      return option?.text;
    },
  },
  methods: {
    dropdownItemClick(option) {
      this.$emit('onClickPeriodFilter', option.value);
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"

.period-dropdown-filter
  ::v-deep button
    border-style: none
    padding: 0
    width: 12rem !important
    min-height: 1.8rem !important
    background-color: rgba(0,0,0,0) !important
  &__button-content
    display: flex
    align-items: flex-end
    justify-content: flex-end
    color: var(--font-color-primary)
    &__text
      font-size: 1rem
      text-transform: none
    &__icon
      font-size: 1.2rem
      margin-left: .4rem
      color: var(--font-color-primary)
</style>
